// extracted by mini-css-extract-plugin
module.exports = {"SpinnerDefault":"index__SpinnerDefault___28h3m","SpinnerLarge":"index__SpinnerLarge___QNruA","SpinnerSeasonal":"index__SpinnerSeasonal___3B4sX"};